export default {
  initWeChatShare(formInfo) {
    const shareInfo = {
      title: formInfo.shareTitle || formInfo.title, // 分享标题,
      desc: formInfo.shareDesc || "", // 分享描述,
      link: formInfo.shortUrl.wap.longUrl,
      imgUrl: "https:" + formInfo.shareImageRealPath.replace(/^https?:/, ""),
    };
    window.$swxsdk.initWxSdk(
      { tenantId: formInfo.tenantId, weChatId: formInfo.attachWXAccount },
      window.apiUrl
    );
    window.$swxsdk.on("sharer", shareInfo);
    window.$swxsdk.on("sharer_friends", shareInfo);
  },
};
